import axios from 'axios';
import {Form} from '@/plugins/FWForms/index';
import * as types from '../mutation-types';

export interface TwistedRoadState {
    init: boolean;
    loading: Record<string, boolean>;
    form: Form<any>;
    connections: any[];
    vehicles: any[];
}

const state: TwistedRoadState = {
    init: false,
    loading: {
        login: false,
        vehicles: false,
        matching: false,
        disconnect: false,
        toggleActive: false,
    },
    form: new Form(),
    connections: [],
    vehicles: [],
};

const getters = {
    init: (state: TwistedRoadState) => state.init,
    loading: (state: TwistedRoadState) => state.loading,
    form: (state: TwistedRoadState) => state.form,
    connections: (state: TwistedRoadState) => state.connections,
    vehicles: (state: TwistedRoadState) => state.vehicles,
};

const mutations = {
    [types.SET_TWISTED_ROAD_LOADING](state: TwistedRoadState, loading: { subject: string, loading: boolean }) {
        state.loading[loading.subject] = loading.loading;
    },
    [types.SET_TWISTED_ROAD_CONNECTIONS](state: TwistedRoadState, connections) {
        state.connections = connections;
    },
    [types.SET_TWISTED_ROAD_VEHICLES](state: TwistedRoadState, vehicles) {
        state.vehicles = vehicles;
    },
};

const actions = {

    async login({commit}, payload: object) {
        commit('SET_TWISTED_ROAD_LOADING', {subject: 'login', loading: true});

        try {
            try {
                await axios.post('/v1/connections/twisted-road/login', payload);
                return true;
            } catch {
                return false;
            }
        } finally {
            commit('SET_TWISTED_ROAD_LOADING', {subject: 'login', loading: false});
        }
    },

    async disconnect({commit}, account) {
        commit('SET_TWISTED_ROAD_LOADING', {subject: 'disconnect', loading: true});

        return axios.delete(`/v1/connections/twisted-road/${account.uuid}`)
            .then(() => {
                return true;
            }).catch(() => {
                return false;
            }).finally(() => {
                commit('SET_TWISTED_ROAD_LOADING', {subject: 'disconnect', loading: false});
            });
    },

    toggleActive({commit}, account) {
        commit('SET_TWISTED_ROAD_LOADING', {subject: 'toggleActive', loading: true});

        axios.put(`/v1/connections/twisted-road/${account.uuid}/toggle-active`)
            .then(() => {
            }).catch(() => {
        }).finally(() => {
            commit('SET_TWISTED_ROAD_LOADING', {subject: 'toggleActive', loading: false});
        });
    },

    fetchVehicles({commit}, payload) {
        commit('SET_TWISTED_ROAD_LOADING', {subject: 'vehicles', loading: true});

        axios.post('/v1/connections/twisted-road/vehicles', payload)
            .then((response) => {
                commit('SET_TWISTED_ROAD_VEHICLES', response?.data?.vehicles);
            }).catch(() => {
        }).finally(() => {
            commit('SET_TWISTED_ROAD_LOADING', {subject: 'vehicles', loading: false});
        });
    },

    /**
     * Match TR Vehicles
     *
     * @param commit
     * @param {Object} data
     */
    matchVehicle({commit}, data) {
        commit('SET_TWISTED_ROAD_LOADING', {subject: 'vehicles', loading: true});

        axios.post('/v1/connections/twisted-road/match-vehicle', data)
            .then(() => {
            }).catch(() => {
        }).finally(() => {
            commit('SET_TWISTED_ROAD_LOADING', {subject: 'vehicles', loading: false});
        });
    },

    /**
     * Match TR Vehicles
     *
     * @param commit
     * @param {Object} data
     */
    unmatchVehicle({commit}, data) {
        commit('SET_TWISTED_ROAD_LOADING', {subject: 'matching', loading: true});

        axios.post('/v1/connections/twisted-road/remove-matched-vehicle', data)
            .then(() => {
            }).catch(() => {
        }).finally(() => {
            commit('SET_TWISTED_ROAD_LOADING', {subject: 'matching', loading: false});
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
